export default __webpack_public_path__ + "static/media/supplier.06403021.xlsx";